import React, {Fragment} from 'react'
import {Text, View, StyleSheet } from '@react-pdf/renderer'

const borderColor = '#7c7f84'
const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
        borderBottomColor: '#7c7f84',
        borderBottomWidth: 1,
        alignItems: 'center',
        height: 48,
        fontStyle: 'bold',
    },
    description: {
        width: '60%',
        textAlign: 'left',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        paddingLeft: 8,
    },
    qty: {
        width: '10%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        textAlign: 'right',
        paddingRight: 8,
    },
    rate: {
        width: '15%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        textAlign: 'right',
        paddingRight: 8,
    },
    amount: {
        width: '15%',
        textAlign: 'right',
        paddingRight: 8,
    },
})


const InvoiceTableRow = ({items}) => {
    const rows = items.map( item =>
        <View style={styles.row} key={item.sno.toString()}>
            <Text style={styles.description}>{item.desc} ({item.eventBy} événements par jour)</Text>
            <Text style={styles.qty}>{item.qty}</Text>
            <Text style={styles.rate}>{item.rate.toFixed(2)}</Text>
            <Text style={styles.rate}>20%</Text>
            <Text style={styles.amount}>{(item.qty * item.rate).toFixed(2)}</Text>
        </View>
    )
    return (<Fragment>{rows}</Fragment> )
}

export default InvoiceTableRow
